import React, { useEffect, useRef, useState } from "react";
import Reactportal from "../../Reactportal/Reactportal";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { useSelector } from "react-redux";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { ClaimSalesConfig } from "./AddClaimSale.config";
import PortalFooter from "../../Reactportal/PortalFooter";
import { useModalContext } from "../../Reactportal/ModalContext";
import { useDispatch } from "react-redux";
import { useLazyQuery, useMutation } from "@apollo/client";
import { createClaimSale, editClaimSale, getClaimSaleById } from "../../../../Utils/AllPagesQuriesAndMutations";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  mergeAllDataIntoFormData,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";

const AddClaimSale = ({ show, TypeOfPortal, submitType = "Save", ParentPortalCloseFunction }) => {
  console.log(TypeOfPortal, "TypeOfPortalPPPPPTypeOfPortal");
  const Form_Key = "Claim_Sales";
  const formRef = useRef({});
  const { pushModal, popModal } = useModalContext();
  const path = window.location.pathname;
  const [formErrors, setFormErrors] = useState({});
  const [field, setFields] = useState(ClaimSalesConfig);
  const [toggle, settoggle] = useState(show ? show : path === "/ClaimSales" ? false : true);
  // const [alldata, setalldata] = useState({});
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.[Form_Key]?.Selected_Row;
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [allFieldsData, setAllFieldsData] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useDispatch();
  const [FormData, setFormdata] = useState({});

  useEffect(() => {
    if (toggle) {
      pushModal(Form_Key);
    }
  }, [toggle, Form_Key, pushModal]);

  const [CreatingData, { loading: createClaimSaleLoading }] = useMutation(createClaimSale, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary", usertype: "sales" },
    },
  });

  const [GetDataByID, { loading: getClaimSaleByIdLoading }] = useLazyQuery(getClaimSaleById, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [EditingData, { loading: editClaimSaleLoading }] = useMutation(editClaimSale, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const ClaimSaleLoadingState = createClaimSaleLoading || getClaimSaleByIdLoading || editClaimSaleLoading;

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Closeformfunction = () => {
    popModal(Form_Key);
    if (path === "/ClaimSales") {
      ParentPortalCloseFunction();
    }
    settoggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };
  console.log(FormData, "salesFprmdatat");
  useEffect(() => {
    setSelectedRows(fielddataRedux?.[Form_Key]?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal !== "Add"&& TypeOfPortal !== "Delete") {
      GetDataByID({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        let ClaimSaleData = { ...data?.getClaimSaleById };
        console.log(ClaimSaleData, "ClaimSaleData");
        ClaimSaleData.Search_Account = ClaimSaleData?.Account_ID?.Unique_Id;
        ClaimSaleData.Account_ID = ClaimSaleData?.Account_ID?.Business_Name;
        ClaimSaleData.Sales_Bill = ClaimSaleData?.Sales_Bill?.Narration;

        const updatedClaimSalesData = { ...ClaimSaleData };
        setAllFieldsData(updatedClaimSalesData);
        updateValueForm(formRef, updatedClaimSalesData);
      });
    }
  }, [fielddata]);

  const { executeOperation } = useSubmitOperation();
  const operationType = "Add";
  let formData = FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);

  const MutationFunctions = {
    CreatingData,
    EditingData,
  };

  useEffect(() => {
    const personName = FormDataFromRedux?.MasterData?.[Form_Key]?.Sales_Person_Mobile_Number;
    if (personName) {
      console.log({ personName }, "personNamepersonNamepersonNamepersonName");
      const value = personName?.Full_Name || FormDataFromRedux?.MasterData?.[Form_Key]?.Sales_Person_Name;
      updateSingleField(formRef, "Sales_Person_Name", value);
    }
  }, [FormDataFromRedux?.MasterData?.[Form_Key]?.Sales_Person_Mobile_Number]);

  useEffect(() => {
    const accountData = FormDataFromRedux?.MasterData?.[Form_Key]?.Search_Account;

    if (accountData) {
      console.log({ accountData }, "personNamepersonNamepersonNamepersonName");
      const value = accountData.Search_Value || accountData.Business_Name || accountData.Proprietor_Name;
      updateSingleField(formRef, "Account_ID", value);
    }
  }, [FormDataFromRedux?.MasterData?.[Form_Key]?.Search_Account]);

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const submit = async (closeAction) => {
    delete formData.Search_Account;
    formData.Sales_Person_ID = FormDataFromRedux?.MasterData[Form_Key]?.Sales_Person_Mobile_Number?._id;
    formData.Account_ID = FormDataFromRedux?.MasterData[Form_Key]?.Search_Account?._id;
    formData.Sales_Bill = FormDataFromRedux?.MasterData[Form_Key]?.Sales_Bill?._id;
    const mutationFunction = getMutationFunction(operationType, MutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
        OnSuccess: (res) => {
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        handleFormReset(formRef);
      },
      onSuccess: () => {},
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      TypeOfPortal={"WARNING"}
      loadingState={ClaimSaleLoadingState}
    />
  );

  return (
    <div>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={path === "/ClaimSales" ? "Claim Sale" : "Add Claim Sale"}
          showCloseIcon={path === "/ClaimSales" ? true : false}
        >
          {ClaimSaleLoadingState && <div className="loader-line-div" />}
          <div className="formContainer">
            {field &&
              field.map((e) => {
                return (
                  <div key={e.id} className="FormSectionParent">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        handelformikdata=""
                        inputfields={e.fields}
                        Type={e.name}
                        onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                        onhandleFormikChange={HanldeChangeonForm}
                        formkey={Form_Key}
                        formRef={formRef}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </Reactportal>
      </div>
    </div>
  );
};

export default AddClaimSale;
